/**
 * Tabs layout script class
 *
 * @package    Layouts
 * @author     Roman Kritskiy <rkritskiy@mindk.com>
 * @copyright  Copyright (c) 2010-2018 MindK (http://mindk.com). All rights reserved.
 * @license    http://mindk.com
 * @link       http://mindk.com
 */

import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';

import { FormattedMessage } from 'react-intl';
import Button from 'Common/CustomButtons/Button';

export default class Tabs extends PureComponent {
    /**
     * @type {Object}
     */
    static propTypes = {
        tabs: PropTypes.array.isRequired,
        active: PropTypes.string.isRequired,
        handleClick: PropTypes.func.isRequired,
        values: PropTypes.object,
        classes: PropTypes.object,
        isSingleDiv: PropTypes.bool,
    };

    static defaultProps = {
        values: {},
        classes: {},
        isSingleDiv: false
    };

    /**
     * @type {Object}
     */
    static contextTypes = {
        intl: PropTypes.object.isRequired,
    };

    render() {
        const { tabs, active, handleClick, values, classes, isSingleDiv } = this.props;

        return (
            <div className={classes.wrapper ? classes.wrapper : 'mm-tabs-wrapper'}>
                {tabs.map(({ name, text, hidden = false }) => {
                    if (hidden) return null;

                    const isActive = active === name;
                    const classes = cx({
                        'mm-tabs-button': true,
                        'mm-tabs-button-active': isActive,
                    });

                    return isSingleDiv ?
                        (
                            <Button type="button" onClick={() => handleClick(name)} key={name} color='white' classes={{button: 'single-row-tab-btn' + (isActive ? ' active-tab-btn' : '')}}>
                                <FormattedMessage id={text} values={values} />
                            </Button>
                        ) :
                        (
                            <div key={name} className={classes}>
                                <Button type="button" onClick={() => handleClick(name)}>
                                    <FormattedMessage id={text} values={values} />
                                </Button>
                            </div>
                        );
                })}
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/Tabs/Tabs.jsx